import isArrayNotEmpty from '@/tools/isarraynotempty';

const toString = (array: Array<{ id: string; name: string }>) => {
  if (!isArrayNotEmpty(array)) return '';
  return array.map(({ name }) => name).join(', ');
};

const parse = (data: any) => ({
  title: data!.name || '',
  competences: toString(data.competences),
  formEducationId: data!.form_education_id || '',
  isOvz: data.is_ovz ? true : false,
  freeCost: data.free_cost ? true : false,
  cost:
    data.cost && typeof data.cost === 'string'
      ? parseFloat(data.cost).toString()
      : '',
  id: data!.id || '',
  professionId: data!.profession_id || '',
  weeks: data.duration_text || '',
  themes: Array.isArray(data.themes) ? data.themes : [],
  studentCategories: isArrayNotEmpty(data.student_categories)
    ? data.student_categories.join(', ')
    : '',
});

const parseModules = (data: any) => data.map((item: any) => parse(item));

export default parseModules;



// WEBPACK FOOTER //
// ./src/services/api/event-modules/utils/parseModules.ts